import HistoryPage from './history-page.vue';

export default HistoryPage;
